"use client";
import React, { type FC } from "react";
import { LinkSafetyProvider } from "./link-safety-provider";
import { useLoadAppConfig } from "../store/app-config-store";
import { LanguageProvider } from "./language-provider";
import { type Messages, type Locale } from "next-intl";
import { enableMapSet } from "immer";
enableMapSet();

interface AppProvidersProps {
  locale: Locale;
  translationMessages: Messages;
  children: React.ReactNode;
}

const AppProviders: FC<AppProvidersProps> = ({
  locale,
  translationMessages,
  children,
}) => {
  // LOAD APP CONFIG
  useLoadAppConfig();

  return (
    <LanguageProvider
      initialLocale={locale}
      initialMessages={translationMessages}
    >
      <LinkSafetyProvider />
      {children}
    </LanguageProvider>
  );
};

export default AppProviders;
